<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">Consumption for Users</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="onClose()"></button>
</div>
<div class="modal-body text-grey">
  <form [formGroup]="billingForm">
    <!-- <div class="mb-3 w-100 d-flex">
      <label for="names" class="w-25">Choose Names</label>
      <div class="input-group w-75">
        <ng-select
          appendTo="body"
          [items]="names"
          bindLabel="key"
          bindValue="value"
          [multiple]="true"
          [closeOnSelect]="false"
          placeholder="Select Names"
          formControlName="names">
          <ng-template ng-header-tmp>
            <div>
              <button class="btn btn-link"
                      (click)="onSelectAll()">Select All</button>
              <button class="btn btn-link"
                      (click)="onClearAll()">Clear All</button>
            </div>
          </ng-template>
          <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
            <div class="ng-value" *ngFor="let item of items | slice:0:2">
              <span class="ng-value-label">{{item.key}}</span>
              <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
            </div>
            <div class="ng-value" *ngIf="items.length > 2">
                <span class="ng-value-label">{{items.length - 2}} more...</span>
            </div>
          </ng-template>
        </ng-select>
      </div>
    </div> -->
    <div class="mb-3 w-100 d-flex">
      <label for="names" class="w-25">Choose User</label>
      <div class="input-group w-75">
        <ng-select appearance="outline" appendTo="body" labelForId="yesno" [searchable]="true" formControlName="names" placeholder="Select User">
          <ng-option *ngFor="let name of names" [value]="name.value">{{ name.key }}</ng-option>
        </ng-select>
      </div>
    </div>
    <div class="mb-3 w-100 d-flex">
      <label for="names" class="w-25">Choose Type</label>
      <div class="input-group w-75">
        <ng-select appearance="outline" appendTo="body" labelForId="yesno" [searchable]="false" formControlName="type" placeholder="Select Type">
          <ng-option *ngFor="let type of billingTypes" [value]="type.value">{{ type.key }}</ng-option>
        </ng-select>
      </div>
    </div>
    <div class="mb-3 w-100 d-flex">
      <label for="period" class="w-25">Period</label>
      <div class="input-group w-75">
        <ng-select appearance="outline" appendTo="body" labelForId="yesno"  [searchable]="false" formControlName="period" placeholder="Select Period">
          <ng-option *ngFor="let type of periodTypes" [value]="type.value">{{ type.key }}</ng-option>
        </ng-select>
        <div *ngIf="billingForm.get('period').value == '0'" class="mt-3">
          <ngb-datepicker 
            #dp 
            (dateSelect)="onDateSelection($event)" 
            [displayMonths]="2" 
            [dayTemplate]="t" 
            outsideDays="hidden" 
            [maxDate]="maxDate"
            ></ngb-datepicker>
          
          <ng-template #t let-date let-focused="focused">
            <span class="custom-day" [class.focused]="focused" [class.range]="isRange(date)"
              [class.faded]="isHovered(date) || isInside(date)" (mouseenter)="hoveredDate = date"
              (mouseleave)="hoveredDate = null">
              {{ date.day }}
            </span>
          </ng-template>
        </div>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-dark" (click)="onClose()">Close</button>
  <button type="button" class="btn btn-primary" (click)="onPreview()">Preview</button>
</div>